import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { HTTP_RESPONSE_CODES } from "../../../../globals/globals";
import { getVendorDiscrepancies } from "../../../../modules/VendorModule/Services/VendorDiscrepancyService";
import { getDropdownData } from "../../../../services/dropdownsConfigService";


const VendorDiscrepancySlice = createSlice({
    name: "vendorDiscrepancies",
    initialState: {
        discrepancies: [],
        discrepancyTypes: {}
    },
    reducers: {
        updateOrder: (state, action) => {
            return { ...state }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchDiscrepancies.fulfilled, (state, action) => {
            let {discrepancies} = action.payload;
            return {...state, discrepancies:discrepancies };
            // return {...state, orders: };
        });
        builder.addCase(fetchDiscrepancyTypes.fulfilled, (state, action) => {
            let {discrepancyTypes} = action.payload;
            return {...state, discrepancyTypes:discrepancyTypes.reduce((acc, curr)=>({...acc, [curr.id]:curr}),{})}
        })
        
    }
});

export const fetchDiscrepancyTypes = createAsyncThunk("vendorDiscrepancy/fetchDiscrepancyTypes", 
    async ({},{getState, rejectWithValue}) => {
        console.warn(`fetching discrepancy types`);
        let response = await getDropdownData(141);
        console.warn('*response 123123', response);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return {discrepancyTypes: response.data.load};
        }
        return rejectWithValue(null);
    }
)

export const fetchDiscrepancies = createAsyncThunk("vendorDiscrepancy/fetchDiscrepancies", 
    async ({companyId}, {getState, rejectWithValue}) => {
        console.warn(companyId);
        let response = await getVendorDiscrepancies(companyId);
        console.warn('*response 123123', response);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return {discrepancies: response.data.load};
        }
        return rejectWithValue(null);
    }
)


export const { updateOrder } = VendorDiscrepancySlice.actions;
export const selectVendorDiscrepancies = (state) => state.vendorDiscrepancy.discrepancies;
export const selectDiscrepancyTypes = (state) => state.vendorDiscrepancy.discrepancyTypes;
export default VendorDiscrepancySlice.reducer;